import { Project } from '@/lib/types'
import { useUX } from '@/ux/context'
import { selectVariant } from '@/ux/selectors'
import { SummaryCard } from './SummaryCard'
import { TechnicalCard } from './TechnicalCard'

interface ProjectCardProps {
  project: Project
}

export function ProjectCard({ project }: ProjectCardProps) {
  const ux = useUX()
  const variant = selectVariant('ProjectCard', ux)

  if (variant === 'TechnicalCard') {
    return <TechnicalCard project={project} />
  }

  return <SummaryCard project={project} />
}
